import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { Map } from 'components/common/GoogleMaps'
import UseMyLocation from '../UseMyLocation'
import { AvailableResultsForm } from '../../../SavedLocationSearchForm'
import {
  ResultsSection,
  MapWrapper,
  SearchWrapper,
  LocationsWrapperAlignedContent
} from '../../../SharedStyledComponents.js'

const StoreLocatorNoResults = props =>
  <ResultsSection>
    <LocationsWrapperAlignedContent>
      <UseMyLocationMiddle { ...props } />
    </LocationsWrapperAlignedContent>
    <MapWrapperNoResults data-at-map-wrapper>
      <SearchWrapper>
        <AvailableResultsForm errorsOnTop { ...props } />
      </SearchWrapper>
      <Map />
    </MapWrapperNoResults>
  </ResultsSection>

export default StoreLocatorNoResults

StoreLocatorNoResults.propTypes = {
  searchMask: PropTypes.string
}

const UseMyLocationMiddle = styled(UseMyLocation)`
  display: inline-block;
  ${Mixin.responsive('padding', '0 20px', '30px 20px 45px 20px')};
  vertical-align: middle;
  width: 100%;
`

const MapWrapperNoResults = styled(MapWrapper)`
  ${Mixin.desktopOnly()}
`
